module.exports = ".row {\n  margin: 10px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/components/elements/input/text/text.component.scss
// module id = ./libs/chassis-core/src/app/resources/components/elements/input/text/text.component.scss
// module chunks = main